import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {MemberService} from '../services/member.service';
import {MemberModel} from '../models/user.model';
import {AlertService} from '../services/notify/alert.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class AdminGuard {

    constructor(
        protected memberService: MemberService,
        protected router: Router,
        protected alert: AlertService,
        protected translate: TranslateService,
    ) {
    }

    async canActivate(): Promise<boolean> {
        const member: MemberModel = await this.memberService.getCurrentMember(true) as MemberModel;

        if (member && (member.project_setting.is_project_admin || member.project_setting.observation_type === 'dep_admin')) {
            return true;
        } else {
            this.alert.setAlert(this.translate.instant('ALERTS.NO_PERMISSIONS'), 'blue');
            await this.router.navigate(['account', 'tasks', 'all']);
            return false;
        }
    }
}
